import RadioGroup from "@/components/forms/radio-group";
import Select from "@/components/forms/select";
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Shield, Info } from 'lucide-react';
import type { DeclarationStepProps } from '@/pages/accident/declaration-sinistre/types';

const Police = (props: DeclarationStepProps) => {
    const { errors, values, setValue } = props;

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <Shield className="w-5 h-5 text-primary" />
                    Forces de police
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-8">
                <RadioGroup
                    label="Il y a-t-il eu intervention des forces de police ?"
                    name="intervention_police"
                    setValue={setValue}
                    options={[{ value: 'T', label: 'Oui' }, { value: 'F', label: 'Non' }]}
                    value={values.intervention_police}
                    error={errors.intervention_police}
                    required
                />

                {values.intervention_police === "T" && (
                    <div className="space-y-5">
                        <Select
                            required
                            name="document_police"
                            error={errors.document_police}
                            label="Sélectionnez le type de document reçu"
                            value={values.document_police}
                        >
                            <option value="">Choisissez le document</option>
                            <option value="O">Procès verbal</option>
                            <option value="M">Main courante</option>
                            <option value="V">Rapport des autorités</option>
                            <option value={undefined}>Ne sait pas</option>
                        </Select>
                        <Alert>
                            <Info className="h-4 w-4" />
                            <AlertDescription>
                                <p className="mb-2">Si vous avez un doute, fiez vous à l'entête du document transmis par les forces de police :</p>
                                <ul className="space-y-1 text-sm ml-1">
                                    <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" />S'il y a indiqué <strong>"Procès verbal"</strong> en tête, choisissez le document <strong>Procès Verbal</strong></li>
                                    <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" />S'il y a indiqué <strong>"Main courante"</strong> en entête, choisissez le document <strong>Main Courante</strong></li>
                                    <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" />S'il y a indiqué <strong>"Rapport"</strong> ou <strong>"Triplicata d'accident"</strong>, choisissez le document <strong>"Rapport des autorités"</strong></li>
                                    <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" />Pour tout autre document, indiquez <strong>"Ne sait pas"</strong>.</li>
                                </ul>
                            </AlertDescription>
                        </Alert>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default Police;
